// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".suggestion[data-v-47e25f10]{margin:15px}.suggestion-products[data-v-47e25f10]{display:grid;gap:14px;padding:0 0 20px}.suggestion-product[data-v-47e25f10]{border:1px solid var(--c-black);flex:1 1 100%}.suggestion .message[data-v-47e25f10]{margin:24px 0}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
